import { useEffect, useState } from 'react';
import UserTable from './ProviderTable';
import UserModal from './ProviderModal';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import { useCreateFuctionMutation, useGetallFunctionQuery, useUpdateFunctionMutation } from 'store/dynamicApi';
import Swal from 'sweetalert2';

function App() {
    const [users, setUsers] = useState([]);
    const [id, setId] = useState('');

    const { data, isLoading } = useGetallFunctionQuery({ url: "/providers" });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [createFuction, { isError: CIsError, error: Cerror, data: CData, isLoading: CIsLoading }] = useCreateFuctionMutation();

    const [updateFunction, { isError: UIsError, error: Uerror, data: UData, isLoading: UIsLoading }] = useUpdateFunctionMutation();

    useEffect(() => {
        if (data) {
            setUsers(data);
        }
    }, [data]);



    useEffect(() => {
        const showAlert = async (msg, icon = 'error') => {
            const toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
            toast.fire({
                icon: icon,
                title: msg,
                padding: '10px 20px',
            });
        };

        if (CIsError) {
            showAlert(Cerror?.data?.msg);
        }

        if (UIsError) {
            showAlert(Uerror?.data?.msg);
        }

        if (CData) {
            showAlert(CData?.msg, 'success');
            handleCloseModal()
        }

        if (UData) {
            showAlert(UData?.msg, 'success');
            handleCloseModal()
        }
    }, [CIsError, Cerror, CData, UIsError, Uerror, UData]);


    const handleAddUser = () => {
        setEditingUser(null);
        setIsModalOpen(true);
    };

    const handleEditUser = (user) => {
        setId(user._id);
        setEditingUser(user);
        setIsModalOpen(true);
    };

    const handleDeleteUser = (userId) => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            setUsers(users?.filter(user => user._id !== userId));
        }
    };

    const handleSubmitUser = async (userData) => {
        if (editingUser) {
            // Update existing user
            setUsers(users?.map(user =>
                user.id === editingUser.id
                    ? { ...user, ...userData }
                    : user
            ));
            const url = '/providers/update';
            await updateFunction({ formData: userData, id: id, url }).unwrap();
        } else {
            const newUser = {
                // id: Date.now(),
                ...userData
            };
            const url = '/providers/register';

            await createFuction({ formData: userData, url }).unwrap();

            setUsers([...users, newUser]);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingUser(null);
    };

    return (
        <div className="min-h-screen bg-background">
            <Header />
            <Sidebar />

            <main className="lg:ml-60 pt-16">
                <div className="min-h-screen bg-gray-50/10 py-8">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8">
                        {/* Header */}
                        <div className="mb-8">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                                <div>
                                    <h1 className="text-3xl font-bold text-gray-100">
                                        Provider Management
                                    </h1>
                                    <p className="mt-2 text-sm text-gray-200">
                                        Manage your users with a beautiful, modern interface
                                    </p>
                                </div>
                                <div className="mt-4 sm:mt-0">
                                    <button
                                        onClick={handleAddUser}
                                        className="inline-flex items-center px-4 py-2 btn-primary"
                                    >
                                        <svg
                                            className="w-5 h-5 mr-2"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                        Add Provider
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* User Table */}
                        <UserTable
                            users={data}
                            onEdit={handleEditUser}
                            onDelete={handleDeleteUser}
                        />

                        {/* Modal */}
                        <UserModal
                            isOpen={isModalOpen}
                            onClose={handleCloseModal}
                            onSubmit={handleSubmitUser}
                            editingUser={editingUser}
                            loading={CIsLoading || UIsLoading}
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}

export default App;